import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Icons from '../common/icons/icons';

const PdfExport = ({ tableData, columns, fileName, classes, name = 'Export to PDF' }) => {
  const exportToPDF = () => {
    const doc = new jsPDF();

    // Add title to the PDF
    doc.text('Table Data Export', 14, 10);
    // Extract column headers
    const tableColumn = ['Patients Name', 'Contact', 'Email', 'Initial Outreach', 'Last Contacted']

    const tableRows = tableData.map((row) =>
      [row.patientName, row.phoneNumber, row.emailAddress, row.initialOutreach, row.lastContacted]
    );

    // Generate PDF table
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      headStyles: {
        minCellHeight: 15, // Adjust the header row height
        maxCellWidth: 70,
        fontSize: 12, // Optional: Change the font size
        fontStyle: 'bold', // Optional: Make the header bold
      },
      columnStyles: {
        0: { cellWidth: 35 }, // First column width
        1: { cellWidth: 30 }, // Second column width
        2: { cellWidth: 30 },
        3: { cellWidth: 43 }, // Second column width
        4: { cellWidth: 43 },
      },
    });

    // Save the PDF file
    doc.save(`${fileName || 'table-data'}.pdf`);
  };

  return (
    <button
      onClick={exportToPDF}
      className={`py-2.5 px-5 me-2 text-sm mt-3 font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 ${classes}`}
    >
      <div className='flex'><Icons status={'pdf'} /><div className='ml-3'>{name}</div></div>
    </button>
  );
};

const buttonStyle = {
  padding: '8px 12px',
  margin: '10px 0',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

export default PdfExport;
